module.exports = __webpack_public_path__ + "img/mickey131.c6aaa294.jpg";